import React from "react";
import { useNavigate } from "react-router-dom";
import { CreditCard, DollarSign, Users, AlertCircle, Send } from "lucide-react";
import { useCartera, useEnviarRecordatorios } from "../hooks/usePagos";
import Layout from "../components/Layout";
import { useAuth } from "../context/AuthContext";

const ESTADO_CLASSES: Record<string,string> = {
  pagado:   "bg-green-50 text-green-700",
  pendiente:"bg-amber-50 text-amber-700",
  vencido:  "bg-red-50 text-red-700",
  beca:     "bg-blue-50 text-blue-700",
};

export default function PagosPage() {
  const nav = useNavigate();
  const { user } = useAuth();
  const academiaId = user?.academia_id || "";
  const { data: cartera, isLoading } = useCartera(academiaId);
  const { mutate: enviarRecordatorios, isPending: enviando } = useEnviarRecordatorios(academiaId);

  return (
    <Layout>
      <div className="p-6 md:p-8 max-w-5xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <div className="flex items-center gap-2 mb-1">
              <CreditCard size={20} className="text-emerald-500"/>
              <h1 className="text-2xl font-bold text-gray-900">Pagos y Cartera</h1>
            </div>
            <p className="text-gray-500 text-sm">Resumen de mensualidades del plantel</p>
          </div>
          <button onClick={() => enviarRecordatorios()} disabled={enviando}
            className="flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 disabled:opacity-50 text-white px-4 py-2.5 rounded-lg text-sm font-medium transition-colors shadow-sm">
            <Send size={15}/> {enviando ? "Enviando..." : "Recordatorios WhatsApp"}
          </button>
        </div>

        {/* KPIs */}
        {!isLoading && cartera && (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
            {[
              { label:"Total jugadores", value: cartera.total_jugadores, icon:<Users size={18}/>, color:"text-gray-700", bg:"bg-gray-50" },
              { label:"Pagados",         value: cartera.pagados,         icon:<CreditCard size={18}/>, color:"text-green-700", bg:"bg-green-50" },
              { label:"Pendientes",      value: cartera.pendientes,      icon:<AlertCircle size={18}/>, color:"text-amber-700", bg:"bg-amber-50" },
              { label:"Recaudado",       value: `$${(cartera.total_recaudado||0).toLocaleString()}`, icon:<DollarSign size={18}/>, color:"text-blue-700", bg:"bg-blue-50" },
            ].map(k=>(
              <div key={k.label} className={`${k.bg} rounded-xl border border-gray-200 p-5`}>
                <div className={`${k.color} mb-2`}>{k.icon}</div>
                <div className={`text-2xl font-bold ${k.color} mb-0.5`}>{k.value ?? 0}</div>
                <div className="text-xs text-gray-500 font-medium">{k.label}</div>
              </div>
            ))}
          </div>
        )}

        {isLoading ? (
          <div className="bg-white rounded-xl border border-gray-200 p-8 animate-pulse">
            <div className="h-4 bg-gray-200 rounded w-1/3 mb-3"/>
            <div className="h-3 bg-gray-100 rounded w-1/2"/>
          </div>
        ) : (
          <div className="bg-white rounded-xl border border-gray-200 p-6">
            <h2 className="font-semibold text-gray-900 mb-3">Gestión individual de pagos</h2>
            <p className="text-sm text-gray-500 mb-4 leading-relaxed">
              Para registrar pagos, subir comprobantes o ver el historial de un jugador específico,
              navega al perfil del jugador desde la sección Jugadores.
            </p>
            <button onClick={() => nav("/jugadores")}
              className="px-4 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-sm font-medium transition-colors">
              Ver jugadores →
            </button>
          </div>
        )}
      </div>
    </Layout>
  );
}

const ESTADO_COLOR: Record<string,{bg:string,color:string}> = {
  pagado:   { bg:"#E8F5E9", color:"#1B5E20" },
  pendiente:{ bg:"#FFF8E1", color:"#F57F17" },
  vencido:  { bg:"#FFEBEE", color:"#B71C1C" },
  beca:     { bg:"#E3F2FD", color:"#1565C0" },
};

